import { useState } from 'react';
import StudioPickerModal from './StudioPickerModal';
import { formatStudioOptionValue } from '../utils/studioOptionLabel';
import {
	FinalCard,
	FinalCardKinks,
	FinalCardVoice,
	FinalConfirmButton,
	FinalEditIcon,
	FinalGrid,
	FinalInputCard,
	FinalNameCard,
	FinalNameCount,
	FinalNameRow,
	FinalRandomButton,
	FinalShell,
	FinalStageSection,
} from '../studio.styles';

const FINAL_FIELDS = [
	'personality',
	'occupation',
	'relationship',
	'nationality',
	'city',
	'zodiac',
	'kinks',
];

const FinalDetailsStage = ({
	finalDetails,
	onUpdate,
	onRandomizeName,
	onConfirm,
	labels,
	lang,
	quizOptions,
}) => {
	const [pickerKind, setPickerKind] = useState('');

	return (
		<>
			<FinalStageSection data-studio-panel="final" aria-label={labels.finalTitle}>
				<FinalShell>
					<FinalGrid>
						<FinalNameCard>
							<span>{labels.name}</span>
							<FinalNameRow>
								<input
									value={finalDetails.name}
									maxLength={20}
									autoComplete="off"
									onChange={(event) => onUpdate('name', event.target.value)}
								/>
								<FinalRandomButton
									type="button"
									aria-label={labels.rerollLook}
									onClick={onRandomizeName}
								>
									<svg viewBox="0 0 24 24" aria-hidden="true">
										<path d="M21 12a9 9 0 0 1-15.2 6.5" />
										<path d="M3 12A9 9 0 0 1 18.2 5.5" />
										<path d="M18 2v4h-4" />
										<path d="M6 22v-4h4" />
									</svg>
								</FinalRandomButton>
							</FinalNameRow>
							<FinalNameCount>
								{finalDetails.name.length}/20
							</FinalNameCount>
						</FinalNameCard>
						<FinalCardVoice type="button" onClick={() => setPickerKind('voice')}>
							<span>{labels.voice}</span>
						<strong>
							{formatStudioOptionValue(lang, 'voice', finalDetails.voice, quizOptions)}
						</strong>
							<FinalEditIcon aria-hidden="true">✎</FinalEditIcon>
						</FinalCardVoice>
						{FINAL_FIELDS.map((key) => {
							if (key === 'city') {
								return (
									<FinalInputCard key={key} htmlFor="studioFinalCity">
										<span>{labels.city}</span>
										<input
											id="studioFinalCity"
											value={finalDetails.city}
											maxLength={40}
											autoComplete="address-level2"
											onChange={(event) => onUpdate('city', event.target.value)}
										/>
									</FinalInputCard>
								);
							}

							const CardComponent = key === 'kinks' ? FinalCardKinks : FinalCard;

							return (
								<CardComponent
									key={key}
									type="button"
									onClick={() => setPickerKind(key)}
								>
									<span>{labels[key]}</span>
									<strong>
										{formatStudioOptionValue(lang, key, finalDetails[key], quizOptions)}
									</strong>
									<FinalEditIcon aria-hidden="true">✎</FinalEditIcon>
								</CardComponent>
							);
						})}
						<FinalConfirmButton type="button" onClick={onConfirm}>
							{labels.confirmFinal}
						</FinalConfirmButton>
					</FinalGrid>
				</FinalShell>
			</FinalStageSection>
			{pickerKind && (
				<StudioPickerModal
					kind={pickerKind}
					value={finalDetails[pickerKind]}
					onClose={() => setPickerKind('')}
					onSelect={(value) => {
						onUpdate(pickerKind, value);
						if (pickerKind !== 'kinks') {
							setPickerKind('');
						}
					}}
					labels={labels}
					quizOptions={quizOptions}
				/>
			)}
		</>
	);
};

export default FinalDetailsStage;
